import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {buttonStyles} from '../../buttons/button'
import {CardActionButton as RmwcCardActionButton} from '@rmwc/card'
import '@rmwc/card/styles'
import '@rmwc/button/styles'

const StyledRmwcCardActionButton = styled(RmwcCardActionButton)`
  ${buttonStyles}
`

const CardActionButton = ({children, type = 'submit', ...otherProps}) => (
  <StyledRmwcCardActionButton type={type} {...otherProps}>
    {children}
  </StyledRmwcCardActionButton>
)

CardActionButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any
}

export {CardActionButton}
